import axios from "../../utils/axios";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  allVideos: [],
  isLoading: false,
  isError: false,
  error: "",
};

export const fetchAllVideos = createAsyncThunk(
  "allVideos/fetchAllVideos",
  async () => {
    const res = await axios.get("/videos");
    return res.data;
  }
);

const allVideoSlice = createSlice({
  name: "allVideos",
  initialState,
  extraReducers: (builder) => {
    builder

      .addCase(fetchAllVideos.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchAllVideos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allVideos = action.payload;
      })
      .addCase(fetchAllVideos.rejected, (state, action) => {
        state.isLoading = false;
        state.allVideos = [];
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default allVideoSlice.reducer;
